export const IMG_MAX_HEIGHT = 600; // px
export const SUCCESS_UPLOAD_REMOVE_TIMEOUT = 1000; // 1 sec
